import type React from 'react';

import { DropzoneOverlay } from '../components/dropzone-overlay';

import { useAssetDropzone } from './use-asset-dropzone';
import { type AllowedFileCategory } from './utils';

type AssetDropzoneProps = {
  allowedFileCategories?: AllowedFileCategory[];
  parentFolderId?: string | null;
  parentFolderName?: string;
  onSuccessfulUpload?: () => void;
  disabled?: boolean;
  children: (props: {
    getRootProps: () => Record<string, unknown>;
    getInputProps: () => Record<string, unknown>;
    open: () => void;
    children: React.ReactNode;
  }) => React.ReactNode;
};

export function AssetDropzone({
  allowedFileCategories = ['image'],
  parentFolderId = null,
  parentFolderName = '',
  onSuccessfulUpload = () => {},
  disabled = false,
  children,
}: AssetDropzoneProps) {
  const { getRootProps, getInputProps, isDragActive, open } = useAssetDropzone(
    allowedFileCategories,
    parentFolderId,
    parentFolderName,
    onSuccessfulUpload,
    { disabled },
  );

  const innerChildren = (
    <>
      <input data-test-id="dropzone-input" {...getInputProps()} />
      <DropzoneOverlay isActive={isDragActive} />
    </>
  );

  return children({
    getRootProps,
    getInputProps,
    open,
    children: innerChildren,
  });
}
